<fieldset>
 <legend>
  Renseignements
 </legend>
 <app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="renseignements.rensgComplt" 
 
[label]="'rensgComplt'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_rensgComplt'">
</app-form-input>

<!---->

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="renseignements.idMarche" 
 
[label]="'idMarche'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_idMarche'">
</app-form-input>
</fieldset>